import { LitElement, html } from 'lit';

import { handleize } from '../utility/strings.js';
import { createRef, ref } from 'lit/directives/ref.js';
import { VPVStoreController } from './vpv-store-controller.js';

import '@decked/decked-design-system/dist/components/button/button.js';
import '@decked/decked-design-system/dist/components/select/select.js';
import '@decked/decked-design-system/dist/components/option/option.js';


class VehiclePicker extends LitElement {
  constructor() {
    super();
  }

  _pickerState = new VPVStoreController(
    this,
    s => s.productVehiclePickerOpen,
    isOpen => {
      this.open = isOpen;
    }
  );

  _urlVehicleState = new VPVStoreController(
    this,
    s => s.urlSetVehicleData,
    isUrlSet => {
      this.urlSetVehicleData = isUrlSet;
    }
  );

  _vehicleJsonReadyState = new VPVStoreController(
    this,
    s => s.vehicleJsonReady,
    isReady => {
      if (isReady && !this.makeOptions?.length) {
        this.collectVehicleData();
        const v = window.VehicleData?.getSelectedVehicle();
        if (v?.make) {
          this.make = v.make;
          this.model = v.model;
          this.year = v.year;
        }
      }
    }
  );

  _vehicleState = new VPVStoreController(
    this,
    s => s.vehicleSelected,
    isSelected => {
      if (isSelected === true) {
        const v = window.VehicleData?.getSelectedVehicle();
        if (v) {
          this.make = v.make;
          this.model = v.model;
          this.year = v.year;
          this.collectVehicleData();
        }
      }
    }
  );

  selects = {
    make: createRef(),
    model: createRef(),
    year: createRef(),
  };

  static properties = {
    make: { type: String, state: true },
    makeOptions: { type: Array, state: true },
    model: { type: String, state: true },
    modelOptions: { type: Array, state: true },
    year: { type: String, state: true },
    yearOptions: { type: Array, state: true },

    open: { type: Boolean, state: true },
    urlSetVehicleData: { type: Boolean, state: true },

    resetUrl: { type: String, attribute: 'reset-url' },
    noVehicleLink: { type: String, attribute: 'no-vehicle-link' },
    pdpPage: { type: Boolean, attribute: 'pdp-page', reflect: true, default: false },
    forceOpen: { type: Boolean, attribute: 'force-open', reflect: true, default: true },
    layout: { type: String, reflect: true },
    filterProducts: {
      type: Boolean,
      attribute: 'filter-products',
      reflect: true,
    },
  };

  connectedCallback() {
    this.innerHTML = '';
    super.connectedCallback();
    this.open = true;

    if (window.VehicleData !== undefined) {
      window.VehicleData.init();
      // Handle already-loaded case — store watch won't fire for pre-existing values
      if (window.__VPV?.vehicleData?.byTemplate?.length) {
        this.collectVehicleData();
        const v = window.VehicleData?.getSelectedVehicle();
        if (v?.make) {
          this.make = v.make;
          this.model = v.model;
          this.year = v.year;
        }
      }
      if (window.__VPV?.store?.urlSetVehicleData) {
        this.urlSetVehicleData = true;
      }
    } else {
      console.error('VehicleData is not defined');
    }
  }

  collectVehicleData() {

    const vehicleData = window.__VPV.vehicleData.byTemplate;
    // Collect all the unique makes
    const makes = new Set();
    const models = new Set();
    const years = new Set();
    for (const vehicle of vehicleData) {
      makes.add(vehicle.make);
      if (this.make == vehicle.make) {
        models.add(vehicle.model);
      }
      if (this.model == vehicle.model && this.make == vehicle.make) {
        years.add(vehicle.year);
      }
    }

    this.makeOptions = Array.from(makes)
      .map(make => ({ value: handleize(make), label: make }))
      .sort(this.sortMakeOptions);
    this.modelOptions = Array.from(models)
      .map(model => ({ value: handleize(model), label: model }))
      .sort(this.sortModelOptions);
    this.yearOptions = Array.from(years)
      .map(year => ({ value: handleize(year), label: year }))
      .sort((a, b) => b.label - a.label);
  }

  clearVehicle() {
    this.make = '';
    this.model = '';
    this.year = '';
    this.open = true;
    this.unFilterProducts();
    window.VehicleData?.reset();
    if (this.resetUrl && window.location.pathname !== new URL(this.resetUrl, location).pathname) {
      window.location = this.resetUrl;
    }
  }

  selectVehicle() {
    if (!this.make || this.make == '' || !this.model || this.model == '' || !this.year || this.year == '') {
      return;
    }
    // const vehicleData = window.__VPV.vehicleData.byTemplate;
    // const selectedVehicle = vehicleData.find(vehicle => {
    //   return vehicle.make == this.make && vehicle.model == this.model && vehicle.year == this.year;
    // });
    // if (selectedVehicle) {
    //   window.VehicleData.selectVehicle({
    //     make: this.make,
    //     model: this.model,
    //     year: this.year
    //   });
    // }

    //NOTE: its better on product pages to just select the make model year, idk if we need to use the above code for other contexts, so I left it as a comment.

    window.VehicleData.selectVehicle({
      make: this.make,
      model: this.model,
      year: this.year
    });

    this.open = false;
    if (this.filterProductsByVehicle) {
      this.filterProductsByVehicle();
    }

    window.dispatchEvent(
      new CustomEvent('vehicleSubmitted', {
        detail: {
          make: this.make,
          model: this.model,
          year: this.year,
        },
        bubbles: true,
        cancelable: true,
        composed: false,
      })
    );
  }


  async updated(changedProperties) {
    if (this.pdpPage && changedProperties.has('open') && window.__VPV?.updateStore) {
      if (this.open) {
        window.__VPV?.updateStore({ productVehiclePickerOpen: true });
      } else {
        window.__VPV?.updateStore({ productVehiclePickerOpen: false });
      }
    }
    await Promise.all(Object.values(this.selects).map(r => r.value?.updateComplete));
    for (const r of Object.values(this.selects)) {
      if (r.value?.popup) r.value.popup.flip = false;
    }
  }

  unFilterProducts = () => {
    const productCards = document.querySelectorAll('product-card');
    productCards.forEach(card => {
      card.classList.remove('product-card--compatible');
      card.classList.remove('product-card--not-compatible');
    });
  };

  filterProductsByVehicle = () => {
    const vehicleData = window.__VPV.vehicleData.bySelection;
    const validProductHandles = new Set();
    for (const vehicle of vehicleData) {
      if (vehicle.make == this.make && vehicle.model == this.model && vehicle.year == this.year) {
        for (const product of vehicle.products) {
          validProductHandles.add(product.productHandle);
        }
      }
    }
    const productCards = document.querySelectorAll('product-card');
    productCards.forEach(card => {
      const productHandle = card.getAttribute('handle');
      if (validProductHandles.has(productHandle) || !productHandle) {
        card.classList.add('product-card--compatible');
        card.classList.remove('product-card--not-compatible');
      } else {
        card.classList.add('product-card--not-compatible');
        card.classList.remove('product-card--compatible');
      }
    });
  };

  selectOption = attribute => e => {
    const value = e.target.value;
    switch (attribute) {
      case 'make':
        this.make = this.makeOptions.find(({ value }) => e.target.value == value).label;
        this.model = '';
        this.year = '';
        break;
      case 'model':
        this.model = this.modelOptions.find(({ value }) => e.target.value == value).label;
        this.year = '';
        break;
      case 'year':
        this.year = this.yearOptions.find(({ value }) => e.target.value == value).label;
        break;
    }
    this.collectVehicleData();
    this.openNextSelect();
  };

  openNextSelect() {
    if (!this.make || this.make == '') {
      this.selects.make.value.show();
    } else if (!this.model || this.model == '') {
      this.selects.model.value.show();
    } else if (!this.year || this.year == '') {
      this.selects.year.value.show();
    }
  }

  sortMakeOptions(a, b) {
    // in reverse order so anything not in the list drops to the end
    const order = ['Mercedes Benz (all Sprinters)', 'Sprinter Van', 'Jeep Trucks', 'Jeep', 'Nissan', 'GMC', 'Toyota', 'Ram', 'Chevy', 'Ford'];

    const indexA = order.indexOf(a.label);
    const indexB = order.indexOf(b.label);
    if (indexA < indexB) {
      return 1;
    } else if (indexA > indexB) {
      return -1;
    } else {
      return 0;
    }
  }

  sortModelOptions(a, b) {
    const containsVanOrService = option => option.label?.includes('Van') || option.label?.includes('Service');

    if (containsVanOrService(a) && !containsVanOrService(b)) {
      return 1;
    } else if (!containsVanOrService(a) && containsVanOrService(b)) {
      return -1;
    } else {
      return a.label.localeCompare(b.label);
    }
  }

  async performUpdate() {
    if (!document.startViewTransition || !this.hasUpdated || !this._$changedProperties?.has('open')) {
      return super.performUpdate();
    }
    this.style.viewTransitionName = 'vehicle-picker';
    const transition = document.startViewTransition(() => super.performUpdate());
    await transition.finished;
    this.style.removeProperty('view-transition-name');
  }

  render() {
    const makeOptions = this.makeOptions?.map(option => html` <sl-option value="${option.value}">${option.label}</sl-option> `);
    const modelOptions = this.modelOptions?.length ? this.modelOptions.map(option => html` <sl-option value="${option.value}">${option.label}</sl-option> `) : html`<sl-option value="please-select" disabled>Please Select Make...</sl-option>`;
    const yearOptions = this.yearOptions?.length ? this.yearOptions.map(option => html` <sl-option value="${option.value}">${option.label}</sl-option> `) : html`<sl-option value="please-select" disabled>Please Select Make...</sl-option>`;

    const makeValue = this.makeOptions?.find(({ label }) => this.make == label)?.value;
    const modelValue = this.modelOptions?.find(({ label }) => this.model == label)?.value;
    const yearValue = this.yearOptions?.find(({ label }) => this.year == label)?.value;

    const vehicleUrl = (() => {
      const u = new URL(window.location.href);
      u.searchParams.set('make', this.make);
      u.searchParams.set('model', this.model);
      u.searchParams.set('year', this.year);
      return u.toString();
    })();

    return html`
      <form>
        ${this.open
          ? html` <div class="flex flex-col ${this.layout == 'vertical' ? '' : 'sm:flex-row'} gap-2 items-start justify-center">
              <sl-select class="w-full ${this.layout == 'vertical' ? '' : 'sm:w-auto'}" ${ref(this.selects.make)} value=${makeValue} placeholder="Make..." size="large" @sl-change=${this.selectOption('make')} placement="bottom" hoist>
                ${makeOptions}
              </sl-select>
              <sl-select class="w-full ${this.layout == 'vertical' ? '' : 'sm:w-auto'}" ${ref(this.selects.model)} value=${modelValue} placeholder="Model..." size="large" @sl-change=${this.selectOption('model')} placement="bottom" hoist>
                ${modelOptions}
              </sl-select>
              <sl-select class="w-full ${this.layout == 'vertical' ? '' : 'sm:w-auto'}" ${ref(this.selects.year)} value=${yearValue} placeholder="Year..." size="large" @sl-change=${this.selectOption('year')} placement="bottom" hoist>
                ${yearOptions}
              </sl-select>
              <sl-button class="w-full ${this.layout == 'vertical' ? '' : 'sm:w-auto'}" variant="primary" size="large" @click=${this.selectVehicle} ?disabled=${!this.make || !this.model || !this.year}>Select Vehicle</sl-button>
              ${this.noVehicleLink ? html`<a class="link mt-2" href="${this.noVehicleLink}">Don't see your vehicle?</a>` : ''}
            </div>`
          : html` ${this.urlSetVehicleData ? html`<div class="banner banner--warning mb-4">Your vehicle was pre-selected from a link. Please verify your fitment.</div>` : ''}
              <div class="flex bg-lightest-grey rounded-sm px-5 py-5 justify-between items-center max-w-xl mx-auto">
                <a href="${vehicleUrl}">${this.make} ${this.model} ${this.year}</a>
                <button class="link" type="reset" @click=${this.clearVehicle}>Change</button>
              </div>`}
      </form>
    `;
  }

  createRenderRoot() {
    return this;
  }
}
if (!window.customElements.get("decked-vehicle-picker")) {
  customElements.define('decked-vehicle-picker', VehiclePicker);
}